<template>
  <div>

    <Cart
        :config="config"
        :cartItems="cartItems"
    />

    <div v-if="!productDetails || (!widthVisible && !heightVisible)">
      <ProductParam
          v-if="thicknessVisible"
          :list="param.thickness"
          :type="'thickness'"
          :label="config.translate.thickness"
          :selection="selection.thickness"
          :available="availableParams.thickness"
          @selected="onParamSelect"
      />
      <ProductParam
          v-if="diameterVisible"
          :list="param.diameter"
          :type="'diameter'"
          :label="config.translate.diameter"
          :selection="selection.diameter"
          :available="availableParams.diameter"
          @selected="onParamSelect"
      />
      <ProductColor
          v-if="colorVisible"
          :list="param.color"
          :type="'color'"
          :label="config.translate.color"
          :selection="selection.color"
          :available="availableParams.color"
          @selected="onParamSelect"
      />

      <div v-if="!canUniqueCut" class="row px-3 mb-4">
        <div class="col-md-4">{{ config.translate.quantity }}:</div>

        <div class="col-md-8">
          <div class="param-quantity">
            <input type="number" v-model="quantity" min="1">
            <p class="product-unit" v-if="productDetails">{{ productDetails.quantity_unit }}</p>
          </div>
        </div>
      </div>
      <div v-if="canUniqueCut" class="tab-pane fade active show transition" :class="{'error-outline':errorCustomCutParameterShow}" id="custom-cut-content" ref="customCutContent"
           role="tabpanel" aria-labelledby="custom-cut-tab">

        <div class="px-3 mb-4">
          <div class="red-text font-weight-bold underline ">{{ config.translate.custom_cut }}<img class="ml-2" style="height:40px" src="/themes/muanyag/img/icons/grey_saw.png" alt=""></div>
        </div>
        <div class="row px-3 mb-4" v-if="!productDetails || productDetails.unit !== 'fm'">
          <div class="col-md-4">{{ config.translate.width }}:</div>

          <div class="col-md-8">
            <div class="param-quantity">
              <input type="number" v-model="cutWidth" min="1">
            </div>
          </div>
        </div>

        <div class="row px-3 mb-4">
          <div class="col-md-4">
            {{ config.translate.length }}:
          </div>

          <div class="col-md-8">
            <div class="param-quantity">
              <input type="number" v-model="cutHeight" min="1">
            </div>
          </div>
        </div>

        <div class="row px-3 mb-4">
          <div class="col-md-4">{{ config.translate.quantity }}:</div>

          <div class="col-md-8">
            <div class="param-quantity">
              <input type="number" v-model="cutQuantity" min="1">
              <p class="product-unit" v-if="productDetails">{{ productDetails.quantity_unit }}</p>
            </div>
          </div>
        </div>

        <div class="error-div" v-if="cutSizeError">
          {{ cutSizeError }}
        </div>

        <div class="info-div" v-if="cutInfo" v-html="cutInfo"></div>
      </div>
    </div>

    <div v-else>
      <div class="tab-content pt-3 mb-3">
        <div class="tab-pane fade active show" id="standard-content" role="tabpanel" aria-labelledby="standard-tab">
            <div class="extra-info px-3 mb-4 mt-3">
             <div class="row">
                <div class="col-4 text-left pt-2">
                  {{ config.translate.unit_price }}:
                </div>
                <div class="col-8 price">
                  <div class="">
                      <strong v-if="productDetails.calc.unitPrice && productDetails.calc.unitPrice > 0" :class="{ strikethrough: !!productDetails.calc.discountPrice }">{{ formatNumber(productDetails.calc.unitPrice) }} {{ productDetails.currency }} / <span v-if="productDetails.unit == 'm2'">m<sup>2</sup></span><span v-else>{{ productDetails.unit }}</span> + {{ config.translate.vat }}</strong>
                      <strong v-else>{{ config.translate.get_interested }}</strong>
                  </div>
                </div>
              </div>
              <div class="row" v-if="productDetails.calc.discountPrice">
                <div class="col-4 text-left pt-2">
                    <strong>{{ config.translate.discount_price }}:</strong>
                </div>
                <div class="col-8 price">
                    <div class="">
                        <strong>{{ formatNumber(productDetails.calc.discountPrice) }} {{ productDetails.currency }} / <span v-if="productDetails.unit == 'm2'">m<sup>2</sup></span><span v-else>{{ productDetails.unit }}</span> + {{ config.translate.vat }}</strong>
                    </div>
                </div>
            </div>
              <p class="select-parameters">{{ config.translate.select_parameters }}</p>
              <div class="underline mt-4"></div>
            </div>
          <ProductParam
              v-if="thicknessVisible"
              :list="param.thickness"
              :type="'thickness'"
              :label="config.translate.thickness"
              :selection="selection.thickness"
              :available="availableParams.thickness"
              @selected="onParamSelect"
          />
          <ProductParam
              v-if="diameterVisible"
              :list="param.diameter"
              :type="'diameter'"
              :label="config.translate.diameter"
              :selection="selection.diameter"
              :available="availableParams.diameter"
              @selected="onParamSelect"
          />
          <ProductColor
              v-if="colorVisible"
              :list="param.color"
              :type="'color'"
              :label="config.translate.color"
              :selection="selection.color"
              :available="availableParams.color"
              @selected="onParamSelect"
          />
          <div class="position-relative">
            <div v-if="isCustomSize" class="disabled-window-part"></div>
            <ProductParam
                v-if="widthVisible"
                :list="param.width.filter(item => item!='no_width')"
                :type="'width'"
                :label="config.translate.width"
                :selection="selection.width"
                :available="availableParams.width"
                @selected="onParamSelect"
            />
            <ProductParam
                v-if="heightVisible"
                :list="param.height.filter(item => item!='no_height')"
                :type="'height'"
                :label="param.width && param.width.length > 1 ? config.translate.length : config.translate.size"
                :selection="selection.height"
                :available="availableParams.height"
                @selected="onParamSelect"
            />
          </div>

        </div>
        <div v-if="canUniqueCut" class="tab-pane fade active show transition" :class="{'error-outline':errorCustomCutParameterShow}" id="custom-cut-content" ref="customCutContent"
             role="tabpanel" aria-labelledby="custom-cut-tab">

          <div class="row px-3 mb-4">
            <div class="pl-3">
              <input type="checkbox" id="needUniqueCut" v-model="needUniqueCut">
            </div>
            <div class="col-md-10 red-text font-weight-bold">
              <label for="needUniqueCut" class="text-underline">{{ config.translate.add_unique_size }}</label>
            </div>
          </div>
          <div id="custom-cut-inner-box">
            <div class="row px-3 mb-4" v-if="!productDetails || productDetails.unit !== 'fm'">
              <div class="col-md-6">
                <div class="mb-2">{{ config.translate.width }}:</div>
                <div><input type="number" v-model="cutWidth" min="1"></div>
              </div>

              <div class="col-md-6">
                <div class="mb-2">{{ config.translate.length }}:</div>
                <div><input type="number" v-model="cutHeight" min="1"></div>
              </div>
            </div>

            <div class="row px-3 mb-4">
              <div class="pl-3">
                <input type="checkbox" v-model="keepLeftover">
              </div>
              <div class="col-md-10">
                {{ config.translate.keep_leftover }}:
                <i class="fa fa-question-circle-o" @mouseenter="setTooltip(config.settings.remains_checkbox_text)"
                  @mouseleave="hideTooltip()"/>
              </div>
            </div>
          </div>

          <div class="error-div" v-if="cutSizeError">
            {{ cutSizeError }}
          </div>

          <div class="info-div" v-if="cutInfo" v-html="cutInfo"></div>
        </div>

        <div class="row px-3 mb-4">
          <div class="col-md-6">
            <div class="mb-2">{{ config.translate.quantity }} ({{ productDetails.quantity_unit }})</div>
            <div><input type="number" id="cuttedQuantity" v-model="cutQuantity" min="1"></div>
            <input type="number" id="normalQuantity" class="open" v-model="quantity" min="1">
          </div>
          <div class="col-md-6" v-if="productDetails.roofing_helper != null">
            <div class="mb-2">&nbsp;</div>
            <a href="/fedeskalkulator" class="fedes-text">{{ config.translate.calculate_with_fed }} </a> 
            <i class="fa fa-question-circle-o" @mouseenter="setTooltip(config.settings.remains_checkbox_text)"
                @mouseleave="hideTooltip()"/>
          </div>
        </div>
      </div>
    </div>

    <Details
        v-if="productDetails"
        :config="config"
        :productDetails="productDetails"
        :multipleTables="multipleTables"
        :tablePrice="tablePrice"
    />

    <div class="row mt-3">
      <div class="col-md-5 col-lg-6">
        <button type="button" class="btn btn-block btn-black-small text-red text-left request-offer mb-3 mb-md-0" @click.prevent="requestOffer()">
          {{ config.translate.unique_offer }}
        </button>
      </div>
      <div class="col-md-7 col-lg-6"
           v-if="productDetails && parseFloat(productDetails.calc.totalPrice) > 0 && productDetails.is_available">
        <button type="button" class="btn btn-block btn-primary-small"  @click.prevent="addToCart()">
          {{ config.translate.add_to_cart }}
        </button>
      </div>
    </div>
  </div>
  <div v-if="(showTooltip || onTooltip)" @mouseover="onTooltip=true" @mouseleave="onTooltip=false" class="popup-vue"
       :style="{top:tooltipPos.top+'px',left:tooltipPos.left+'px'}" v-html="tooltip"></div>
</template>

<script>
import Cart from './components/Cart.vue'
import Details from './components/Details.vue'
import ProductParam from './components/ProductParam.vue'
import ProductColor from './components/ProductColor.vue'

export default {
  name: 'App',
  components: {
    Cart,
    Details,
    ProductParam,
    ProductColor,
  },
  data() {
    let config = window.vueProductConfig;

    return {
      config,
      param: {},
      items: {},
      cartItems: [],
      selection: {
        thickness: null,
        diameter: null,
        color: null,
        width: null,
        height: null,
        productId: null,
      },
      availableParams: {
        thickness: [],
        diameter: [],
        color: [],
        width: [],
        height: [],
        outOfStock: [],
      },
      productDetails: null,
      quantity: 1,
      cutWidth: null,
      cutHeight: null,
      cutQuantity: 1,
      keepLeftover: 0,
      tablePrice: 0,
      cutSizeError: false,
      cutInfo: false,
      multipleTables: false,
      tab: 'standard',
      debounceTimeout: null,
      cartData: null,
      initialSelect: false,
      tooltip: false,
      showTooltip: false,
      onTooltip: false,
      tooltipPos: {top: 0, left: 0},
      isCustomSize: false,
      errorCustomCutParameterShow:false,
      errorOutlineTimeout: null,
      canUniqueCut:false,
      needUniqueCut:false,
    }
  },
  mounted() {
    this.axios.get(this.config.variationsUrl)
        .then((res) => {
          let params = [];
          this.items = res.data.items;

          params.thickness = res.data.thickness.sort((a, b) => a - b);
          params.diameter = res.data.diameter.sort((a, b) => {
            let aSizes = a.toString().split('/'),
                bSizes = b.toString().split('/');

            if (parseFloat(aSizes[0]) == parseFloat(bSizes[0]) && aSizes.length == 2 && bSizes.length == 2)
              return parseFloat(aSizes[1]) - parseFloat(bSizes[1]);

            return parseFloat(aSizes[0]) - parseFloat(bSizes[0]);
          });

          params.width = res.data.width.sort((a, b) => a - b);
          params.height = res.data.height.sort((a, b) => a - b);
          params.color = res.data.color;
          params.original = res.data.original;

          this.param = params;
          this.initialSelect = true,
              this.setAvailableVariants();
        })
        .catch((err) => {
          // eslint-disable-next-line
          console.error(err);
        });
  },
  computed: {
    thicknessVisible() {
      return this.isParamVisible('thickness');
    },
    diameterVisible() {
      return this.isParamVisible('diameter');
    },
    colorVisible() {
      return this.isParamVisible('color');
    },
    widthVisible() {
      return this.isParamVisible('width');
    },
    heightVisible() {
      return this.isParamVisible('height');
    },
  },
  methods: {
    formatNumber(number){
      return new Number(number).toLocaleString(this.productDetails.ccy_code, {minimumFractionDigits: this.productDetails.ccy_precision});
    },
    pushAddToCartEvent() {
      if (!this.config.gtmItem) {
        return;
      }

      let totalPrice = this.productDetails && this.productDetails.calc ? parseFloat(this.productDetails.calc.totalPrice) : 0;
      let quantity = parseFloat(this.quantity) || 1;

      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({ ecommerce: null });
      window.dataLayer.push({
        event: 'add_to_cart',
        ecommerce: {
          currency: String(this.config.gtmItem.currency).toUpperCase(),
          value: totalPrice,
          items: [
            Object.assign({}, this.config.gtmItem, {
              price: totalPrice / quantity,
              quantity: quantity,
            }),
          ],
        },
      });
    },
    isParamVisible(param) {
      if (this.param && Object.prototype.hasOwnProperty.call(this.param, param) && this.param[param] && this.param[param].length > 0) {
        if (this.param[param].length > 1)
          return true;

        if (this.param[param].length == 1 && this.param[param][0] != 'no_' + param)
          return true;
      }

      return false;
    },
    setAvailableVariants() {
      let thickness = null,
          diameter = null,
          color = null,
          width = null,
          height = null;

      if (!this.selection.thickness) {
        if (this.param.thickness && this.param.thickness.length) {
          let thicknesses = Object.values(this.items);
          this.availableParams.thickness = thicknesses;

          if (this.param.original && this.param.original.thickness && this.items[this.param.original.thickness]) {
            this.selection.thickness = this.items[this.param.original.thickness];
          } else
            this.selection.thickness = this.availableParams.thickness[0];

          thickness = this.selection.thickness.key;
        }
      } else
        thickness = 'thickness_' + (this.selection.thickness.value == null || parseFloat(this.selection.thickness.value) == 0 ? 'no_thickness' : this.selection.thickness.value);

      if (thickness) {
        if (!this.selection.diameter) {
          if (this.items && this.items[thickness]) {
            let diameters = Object.values(this.items[thickness]['items']);

            this.availableParams.diameter = diameters
                .filter(value => value.key !== 'diameter_no_diameter')
                //.map(value => value.key.toString().replace('diameter_', ''))
                .sort((a, b) => {
                  let aSizes = a.value.toString().split('/'),
                      bSizes = b.value.toString().split('/');

                  if (parseFloat(aSizes[0]) == parseFloat(bSizes[0]) && aSizes.length == 2 && bSizes.length == 2)
                    return parseFloat(aSizes[1]) - parseFloat(bSizes[1]);

                  return parseFloat(aSizes[0]) - parseFloat(bSizes[0]);
                });

            if (this.param.original &&
                this.param.original.thickness &&
                this.param.original.diameter &&
                this.items[this.param.original.thickness] &&
                this.items[this.param.original.thickness]['items'][this.param.original.diameter]
            ) {
              this.selection.diameter = this.items[this.param.original.thickness]['items'][this.param.original.diameter];
            } else
              this.selection.diameter = diameters[0];

            diameter = this.selection.diameter.key;
          }
        } else
          diameter = 'diameter_' + (this.selection.diameter.value == null ? 'no_diameter' : this.selection.diameter.value.toString().replace('/', '_'));

        if (diameter) {
          if (!this.selection.color) {
            if (this.items && this.items[thickness]['items'][diameter]) {
              let colors = Object.values(this.items[thickness]['items'][diameter]['items']);
              this.availableParams.color = colors;

              if (this.param.original &&
                  this.param.original.thickness &&
                  this.param.original.diameter &&
                  this.param.original.color &&
                  this.items[this.param.original.thickness] &&
                  this.items[this.param.original.thickness]['items'][this.param.original.diameter] &&
                  this.items[this.param.original.thickness]['items'][this.param.original.diameter]['items'][this.param.original.color]
              ) {
                this.selection.color = this.items[this.param.original.thickness]['items'][this.param.original.diameter]['items'][this.param.original.color];
              } else
                this.selection.color = colors[0];

              color = this.selection.color.value;
            }
          } else
            color = (this.selection.color.value == null ? 'no_color' : this.selection.color.value);

          if (color) {
            if (!this.selection.width) {
              if (this.items && this.items[thickness]['items'][diameter]['items'][color]) {
                let widths = Object.values(this.items[thickness]['items'][diameter]['items'][color]['items']);
                this.availableParams.width = widths.sort((a, b) => {
                  return (a.key.toString().replace('width_', '') * 1) - (b.key.toString().replace('width_', '') * 1);
                });
                if (thickness &&
                    diameter &&
                    color &&
                    this.param.original &&
                    this.param.original.width &&
                    this.items[thickness] &&
                    this.items[thickness]['items'][diameter] &&
                    this.items[thickness]['items'][diameter]['items'][color] &&
                    this.items[thickness]['items'][diameter]['items'][color]['items'][this.param.original.width]
                ) {
                  this.selection.width = this.items[thickness]['items'][diameter]['items'][color]['items'][this.param.original.width];
                } else
                  this.selection.width = widths[0];

                width = this.selection.width.key;
              }
            } else
              width = 'width_' + this.selection.width.value;

            if (width) {
              if (!this.selection.height) {
                if (this.items && this.items[thickness]['items'][diameter]['items'][color]['items'][width]) {
                  let heights = Object.values(this.items[thickness]['items'][diameter]['items'][color]['items'][width]['items']);
                  this.availableParams.height = heights.sort((a, b) => {
                    return (a.key.toString().replace('height_', '') * 1) - (b.key.toString().replace('height_', '') * 1);
                  });

                  if (this.param.original &&
                      this.param.original.thickness &&
                      this.param.original.diameter &&
                      this.param.original.color &&
                      this.param.original.width &&
                      this.param.original.height &&
                      this.items[thickness] &&
                      this.items[thickness]['items'][diameter] &&
                      this.items[thickness]['items'][diameter]['items'][color] &&
                      this.items[thickness]['items'][diameter]['items'][color]['items'][width] &&
                      this.items[thickness]['items'][diameter]['items'][color]['items'][width]['items'][this.param.original.height]
                  ) {
                    this.selection.height = this.items[thickness]['items'][diameter]['items'][color]['items'][width]['items'][this.param.original.height];
                  } else
                    this.selection.height = heights[0];

                  height = this.selection.height.key;
                }
              } else
                height = 'height_' + this.selection.height.value;

              if (height) {
                if (this.items && this.items[thickness]['items'][diameter]['items'][color]['items'][width]['items'][height])
                  this.selection.productId = this.items[thickness]['items'][diameter]['items'][color]['items'][width]['items'][height]['items'];
              }
            }
          }
        }
      }

      this.initialSelect = false;
      this.getProductDetails();
    },
    onParamSelect(item) {
      this.selection[item.type] = item;

      if (item.type == 'thickness')
        this.selection.diameter = this.selection.color = this.selection.width = this.selection.height = null;
      if (item.type == 'diameter')
        this.selection.color = this.selection.width = this.selection.height = null;
      if (item.type == 'color')
        this.selection.width = this.selection.height = null;
      if (item.type == 'width')
        this.selection.height = null;

      this.cutWidth = null;
      this.cutHeight = null;
      this.cutQuantity = 1;

      if (item.type == 'width' || item.type == 'height')
        this.isCustomSize = false;

      this.setAvailableVariants();
    },
    getProductDetails() {
      let data = {
        id: this.selection.productId,
        quantity: this.quantity,
      };

      if (this.selection.width && this.selection.width.value && !Number.isNaN(this.selection.width.value))
        data.width = this.selection.width.value;
      if (this.selection.height && this.selection.height.value && !Number.isNaN(this.selection.height.value))
        data.height = this.selection.height.value;

      let params = this.encodeQueryData(data);

      if (this.selection.productId)
        this.axios.get(this.config.detailsUrl + '?' + params)
            .then((res) => {
              this.productDetails = res.data;
              this.multipleTables = false;
              this.tablePrice = res.data.calc.tablePrice;
              this.cartData = res.data.calc.cart_data;
              this.canUniqueCut = res.data.canUniqueCut;
              let productData = res.data.product;
              if (productData && (productData.image || productData.description || productData.short || productData.uses)) {
                let data = {};

                if (productData.image)
                  data.image = productData.image;
                if (productData.description)
                  data.description = productData.description;
                if (productData.short)
                  data.short = productData.short;
                if (productData.uses)
                  data.uses = productData.uses;
                if (productData.workability)
                  data.workability = productData.workability;
                if (productData.properties)
                  data.properties = productData.properties;
                if (productData.images)
                  data.images = productData.images;

                data.isDiscount = !!res.data.calc.discountPrice;

                let event = new CustomEvent("product-change-data", {
                      detail: data,
                      bubbles: true,
                      cancelable: true
                    }
                );

                document.body.dispatchEvent(event);
              }
            })
            .catch((err) => {
              // eslint-disable-next-line
              console.error(err);
            });
    },
    getCustomCutDetails() {
      if(!this.isCustomSize){
        this.getProductDetails();
      }else {
        let cutWidth = parseInt(this.cutWidth);
        let cutHeight = parseInt(this.cutHeight);
        let cutQuantity = parseInt(this.cutQuantity);

        let isOnlyLength = this.productDetails.unit == 'fm';

        //if ((cutWidth > 0 || isOnlyLength) && cutHeight > 0 && cutQuantity > 0) {
        let data = {
          width: isOnlyLength ? '' : cutWidth,
          height: cutHeight,
          quantity: cutQuantity,
        }

        if (this.selection.thickness && this.selection.thickness.value)
          data.thickness = this.selection.thickness.value;
        if (this.selection.diameter && this.selection.diameter.value)
          data.diameter = this.selection.diameter.value;
        if (this.selection.color && this.selection.color.value)
          data.color = this.selection.color.value.toString().replace('color_', '');
        if (this.keepLeftover)
          data.leftover = this.keepLeftover;

        this.axios.get(this.config.cutUrl + '&' + this.encodeQueryData(data))
            .then((res) => {
              if (res.data.error) {
                this.cutSizeError = res.data.error;
                this.cutInfo = null;
                this.productDetails.is_available = res.data.is_available;
                this.productDetails.stock_status = res.data.stock_status;
              } else {
                this.cutSizeError = false;
                this.productDetails.is_available = res.data.is_available;
                this.productDetails.stock_status = res.data.stock_status;
                this.productDetails.display_payable_quantity = res.data.display_payable_quantity;
                this.productDetails.display_needed_quantity = res.data.display_needed_quantity;
                if (res.data.calc) {
                  this.productDetails.calc.unitPrice = res.data.calc.unitPrice;
                  this.productDetails.calc.totalPrice = res.data.calc.totalPrice;
                  this.productDetails.calc.totalGrossPrice = res.data.calc.totalGrossPrice;
                  this.cutInfo = res.data.calc.info;
                  this.multipleTables = res.data.calc.tableQuantity > 1;
                  this.tablePrice = res.data.calc.tablePrice;
                  this.cartData = res.data.calc.cart_data;
                }
              }
            })
            .catch((err) => {
              // eslint-disable-next-line
              console.error(err);
            });
        //}
      }
    },
    addToCart() {
      let _this = this;
      if(this.cutSizeError && this.isCustomSize){
        this.errorCustomCutParameterShow = true;
        let container = this.$refs.customCutContent;
        container.scrollIntoView({behavior: 'smooth',block:'center'});
        this.errorOutlineTimeout = setTimeout(() => {
          this.errorCustomCutParameterShow = false;
        }, 400);
      }else {
        this.axios.post(this.config.cartUrl, {cart_data: this.cartData}, {headers: {'X-CSRF-Token': this.config.csrf}})
            .then((res) => {
              // Kosárhoz adott termékek
              _this.cartItems = res.data.cartItems;

              // Kosár ikon frissítése
              if (parseInt(res.data.cartCount)) {
                document.getElementById("button-cart-counter").style.opacity = "1";
                document.getElementById("cart-count").innerHTML = parseInt(res.data.cartCount);
              } else {
                document.getElementById("button-cart-counter").style.opacity = "0";
                document.getElementById("cart-count").innerHTML = 0;
              }

              _this.pushAddToCartEvent();
            })
            .catch((err) => {
              // eslint-disable-next-line
              console.error(err);
            });
      }
    },
    encodeQueryData(data) {
      const ret = [];
      for (let d in data)
        ret.push(encodeURIComponent(d) + '=' + encodeURIComponent(data[d]));
      return ret.join('&');
    },
    debounceCutDetails() {
      if(this.cutWidth || this.cutHeight){
        this.isCustomSize = true;
      }else{
        this.isCustomSize = false;
      }
      clearTimeout(this.debounceTimeout);

      this.debounceTimeout = setTimeout(() => {
        this.getCustomCutDetails();
      }, 500);
    },
    requestOffer() {
      let data = {
        id: this.selection.productId,
      };

      if (!this.isCustomSize) {
        data.quantity = this.quantity;

        if (this.selection.width && this.selection.width.value && !Number.isNaN(this.selection.width.value))
          data.width = this.selection.width.value;
        if (this.selection.height && this.selection.height.value && !Number.isNaN(this.selection.height.value))
          data.height = this.selection.height.value;
      } else {
        let cutWidth = parseInt(this.cutWidth);
        let cutHeight = parseInt(this.cutHeight);
        let cutQuantity = parseInt(this.cutQuantity);

        if (cutWidth)
          data.cut_width = cutWidth;
        else
          data.cut_width = ' ';
        if (cutHeight)
          data.cut_height = cutHeight;
        if (cutQuantity)
          data.quantity = cutQuantity;
        if (this.keepLeftover)
          data.leftover = this.keepLeftover;

      }
      if (!this.isCustomSize || ( this.cutHeight && this.cutQuantity)) {

        let event = new CustomEvent("product-request-offer", {
              detail: data,
              bubbles: true,
              cancelable: true
            }
        );

        document.body.dispatchEvent(event);
      } else {
        alert(this.config.translate.unique_offer_error_specify_width_height);
      }
    },
    setTooltip(text) {
      if (!this.showTooltip && !this.onTooltip) {
        this.showTooltip = true;
        this.tooltip = text;
        this.tooltipPos = {
          left: event.pageX,
          top: event.clientY,
        }
      }
    },
    hideTooltip() {
      var _this = this;
      setTimeout(() => {
        _this.showTooltip = false
      }, 20);
    }
  },
  watch: {
    quantity: function () {
      this.getProductDetails();
    },
    cutWidth: function () {
      this.debounceCutDetails();
    },
    cutHeight: function () {
      this.debounceCutDetails();
    },
    cutQuantity: function () {
      this.debounceCutDetails();
    },
    keepLeftover: function () {
      this.debounceCutDetails();
    },
    needUniqueCut: function () {
      document.getElementById("custom-cut-inner-box").classList.toggle("open");
      document.getElementById("cuttedQuantity").classList.toggle("open");
      document.getElementById("normalQuantity").classList.toggle("open");
    }
  }
}
</script>
